import React, { useRef } from 'react';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  Theme,
  Popper,
  List,
} from '@material-ui/core';

import { useDropdown } from '../../hooks';

const useStyles = makeStyles(({ palette, colors }: Theme) => createStyles({
  root: {
    display: 'inline-block',
    width: 'fit-content',
  },
  arrowTop: {
    position: 'absolute',
    display: 'block',
    width: '2rem',
    height: '1rem',
    top: '0',
    left: '0.5rem',
    '&::after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      borderColor: 'transparent',
      borderBottomColor: '#fff',
      borderWidth: '0 1rem 1rem 1rem',
      borderStyle: 'solid',
      top: '1px',
    },
    '&::before': {
      position: 'absolute',
      display: 'block',
      content: "''",
      borderColor: 'transparent',
      borderBottomColor: colors.border,
      borderWidth: '0 1rem 1rem 1rem',
      borderStyle: 'solid',
      top: '0',
    },
  },
  arrowBottom: {
    position: 'absolute',
    display: 'block',
    width: '2rem',
    height: '1rem',
    bottom: 0,
    left: '0.5rem',
    '&::after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      borderColor: 'transparent',
      borderTopColor: '#FFF',
      borderWidth: '1rem 1rem 0 1rem',
      borderStyle: 'solid',
      top: '0',
    },
    '&::before': {
      position: 'absolute',
      display: 'block',
      content: "''",
      borderColor: 'transparent',
      borderTopColor: colors.border,
      borderWidth: '1rem 1rem 0 1rem',
      borderStyle: 'solid',
      top: '1px',
    },
  },
  menuButton: {
    display: 'inline-block',
    color: palette.text.primary,
    '&:hover': {
      color: palette.menuAction.hover
    },
    '&:focus': {
      outline: 'none',
    },
    cursor: 'pointer',
  },
  icon: {
    color: colors.selected,
    width: 16,
    height: 16,
  },
  menuIcon: {
    padding: '3px 0',
    color: palette.icons.default,
  },
  openedMenuIcon: {
    color: palette.menuAction.hover,
  },
  menu: {
    minWidth: 150,
    maxWidth: 300,
    padding: '5px',
    zIndex: 2147483100,
  },
  menuContainerBottom: {
    border: `1px solid ${colors.border}`,
    padding: '5px',
    background: '#fff',
    margin: '0.6rem 0 0 0',
    boxShadow: '1px 1px 10px 1px rgba(0,0,0,0.12)',
  },
  menuContainerTop: {
    border: `1px solid ${colors.border}`,
    padding: '5px',
    background: '#fff',
    margin: '0 0 0.6rem 0',
    boxShadow: '1px 1px 10px 1px rgba(0,0,0,0.12)',
  }
}), { name: 'ActionCell' });

type Props = {
  className?: string;
  classNameButtonWrapper?: string;
  children: React.ReactNode;
  title: React.ReactNode;
  onMouse?: boolean;
};

const stopPropagation: React.MouseEventHandler = (e) => {
  e.stopPropagation();
};

const CustomActionCell = ({ children, className, title, onMouse = false, classNameButtonWrapper }: Props) => {
  const menuRef = useRef<HTMLDivElement | null>(null);

  const classes = useStyles();

  const {
    isOpened, open, close, toggle,
  } = useDropdown();

  return (
    <div className={clsx(classes.root, className)} onClick={stopPropagation}>
      <div
        ref={menuRef}
        className={classNameButtonWrapper ? classNameButtonWrapper : ''}
      >
        <div
          tabIndex={-1}
          {...(onMouse && { onMouseEnter:open, onMouseLeave:close })}
          onClick={toggle}
          className={classes.menuButton}
        >
          {title}
        </div>
      </div>
      <Popper
        hidden={!isOpened}
        anchorEl={menuRef.current}
        open={isOpened}
        onMouseLeave={close}
        onClick={close}
        placement="bottom-start"
        className={classes.menu}
        keepMounted
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'window',
          },
        }}
      >
        {({ placement }) => (
          <div className={(placement.indexOf('bottom') !== -1)? classes.menuContainerBottom : classes.menuContainerTop}>
            <i className={(placement.indexOf('bottom') !== -1)? classes.arrowTop : classes.arrowBottom} />
            <List>
              {children}
            </List>
          </div>
        )}
      </Popper>
    </div>
  );
};

export default CustomActionCell;
